import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

import {
  AvatarSize,
  AvatarStyle,
  getAvatarClassNames,
  getIconClassNames,
} from "./class-names";
import { Icon, IconName } from "../icon";

type AvatarProps = {
  style?: AvatarStyle;
  size: AvatarSize;
  text?: string;
  icon?: IconName;
  disabled?: boolean;
  active?: boolean;
  bgColor?: string;
  className?: string;
  tabIndex?: number;
};

export const Avatar = ({
  text,
  icon,
  size,
  style = "square",
  disabled,
  active,
  bgColor,
  className,
  tabIndex = 0,
}: AvatarProps) => (
  <div
    tabIndex={tabIndex}
    className={twMerge(
      clsx(
        getAvatarClassNames({ size, style, disabled, active, bgColor }),
        className,
      ),
    )}
  >
    {icon ? (
      <Icon name={icon} className={getIconClassNames(size)} />
    ) : (
      <span className="truncate">{text}</span>
    )}
  </div>
);
